import React from 'react';


import component, {classnames} from './component';


export default component('TopActionButtons', function({children}) {

  return (
    <div className='TopActionButtons'>
      {children}
    </div>
  )

});




// WEBPACK FOOTER //
// ./src/components/TopActionButtons.js